module.exports = __webpack_public_path__ + "static/media/bathtub.0dea3f87.png";